import 'leaflet/dist/leaflet.css';
import 'leaflet/dist/leaflet';

let marqueurs = [];
let latLngBounds = [];

window.addEventListener('load', function () {
    const carteWrapper = document.getElementById('carte-antenne-wrapper');

    if (carteWrapper != null) {
        const donneesElement = carteWrapper.querySelector('.js-carte-donnees');

        //Récupération de la latitude et longitudes
        const latitude = donneesElement.getAttribute('data-carte-latitude');
        const longitude = donneesElement.getAttribute('data-carte-longitude');

        //Récupération de la liste des antennes
        const antennesJson = donneesElement.getAttribute('data-carte-antennes');
        const antennes = JSON.parse(antennesJson);

        //Suppression du DOM de l'élément qui contient les données
        donneesElement.remove();

        //Définition des marqueurs
        const iconeMarqueurDefaut = L.icon({
            iconUrl: donneesElement.getAttribute('data-carte-marqueurs-folder-url') + 'defaut.svg',
            iconSize: [36, 44],
            iconAnchor: [18, 22],
            popupAnchor: [-3, -76],
            shadowUrl: ''
        });

        const iconeMarqueurActif = L.icon({
            iconUrl: donneesElement.getAttribute('data-carte-marqueurs-folder-url') + 'active.svg',
            iconSize: [36, 44],
            iconAnchor: [18, 22],
            popupAnchor: [0, -20],
            shadowUrl: ''
        });

        //Définition du centre de la carte
        const coordonnesCentreCarte = [parseFloat(latitude), parseFloat(longitude)];

        //Création de la map
        const carte = L.map('carte-antennes', {
            center: coordonnesCentreCarte,
            zoom: 8,
            scrollWheelZoom: false,
            dragging: !L.Browser.mobile,
        });

        //Lorsque la taille de la fenêtre change, recharger la carte
        const bodyElement = document.querySelector("body");
        const resizeObserver = new ResizeObserver(() => {
            carte.invalidateSize();
        });
        resizeObserver.observe(bodyElement);

        //Création du Layer
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(carte);

        if (antennes != null && antennes.length > 0) {
            antennes.forEach((antenne) => {
                const latLng = L.latLng(antenne.latitude, antenne.longitude);
                const marqueur = L.marker(latLng, {
                    icon: iconeMarqueurDefaut,
                    riseOnHover: true,
                    title: antenne.city,
                });
                marqueur.addTo(carte);

                //Définir des champs "custom" pour le marqueur (pour pouvoir changer l'icone facilement)
                marqueur.defaultIcon = iconeMarqueurDefaut;
                marqueur.activeIcon = iconeMarqueurActif;

                //Gestion du on click
                marqueur.on('click', () => {
                    clearListMapStates();
                    marqueur.setIcon(iconeMarqueurActif);
                    marqueur.setZIndexOffset(1000);

                    //on centre la carte sur le marker
                    carte.panTo(marqueur.getLatLng());

                    //Gestion du contenu de la popup
                    marqueur.bindPopup(getPopupAntenneHtml(antenne)).openPopup();

                    //Détecter quand la popup est fermée pour remettre le marqueur par défaut
                    marqueur.getPopup().on('remove', function () {
                        clearListMapStates();
                    });
                });

                marqueurs.push(marqueur);
                latLngBounds.push(latLng);
            });

            carte.fitBounds(latLngBounds);
        }
    }
});

const getPopupAntenneHtml = (antenne) => {
    const joursSemaine = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

    let openingHoursFormatted = '';
    if (antenne.openingHours != null && JSON.parse(antenne.openingHours).length > 0) {
        let openingHours = JSON.parse(antenne.openingHours);
        for (let i = 0; i < openingHours.length; i++) {
            if (openingHours[i] !== null && openingHours[i] !== '') {
                openingHoursFormatted += `<div class="antenne-popup-horaire">
                    <div class="antenne-popup-horaire-libelle">
                        ${joursSemaine[i]}
                    </div>
                    <div class="antenne-popup-horaire-valeur">
                        ${openingHours[i]}
                    </div>
                </div>`;
            }
        }
    }

    return `<div class="antenne-popup-wrapper">
        <div class="antenne-popup-titre">
            Antenne de ${antenne.city}
        </div>
        <adress class="antenne-popup-adresse">
            ${antenne.address}<br />
            ${antenne.postcode} ${antenne.city}<br />
        </adress>
        ${antenne.phone != null && antenne.phone !== '' ?
        `<p class="antenne-popup-description"><a href="${getPhoneNumberLink(antenne.phone)}">${antenne.phone}</a></p>` : ''
    }
        ${openingHoursFormatted !== '' ?
        `<div class="antenne-popup-horaires">
            <div class="antenne-popup-horaires-titre">
                Horaires d'ouvertures
            </div>
            ${openingHoursFormatted}
        </div>` : ''
    }
        
    </div>`;
}

const clearListMapStates = () => {
    //Remise à zéro des markers actif
    marqueurs.forEach((marker) => {
        marker.setIcon(marker.defaultIcon);
        marker.setZIndexOffset(0);

        if (marker.getPopup()) {
            marker.closePopup();
            marker.unbindPopup();
        }
    })
}

const getPhoneNumberLink = (phone) => {
    phone = phone.replace('+33', '');
    phone = phone.substring(1);
    phone = phone.replace(/[\s.\(0\)]/g, '');

    return 'tel:+33' + phone;
}